export function getTenantDisplayName(
  tenant: { display_name: string } | null | undefined,
  is_personal?: boolean
) {
  return is_personal ? 'Personal' : tenant?.display_name;
}
